import React from 'react';
import { Excel } from '../components/excel';

/**
 *
 * @param {Object[]} columns
 * @param {Object[]} data
 * @param {Function} rows
 * @param {string} name
 * @returns {Function} createExcel
 */
const useExportExcel = (columns, data, rows, name) => {
  const createExcel = () => new Excel(columns, data, rows, name).createExcel();
  return createExcel;
};

export default useExportExcel;
